import { __awaiter } from 'tslib';
import * as i0 from '@angular/core';
import { EventEmitter, Injectable, Component, Input, Pipe, NgModule } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { getRoute } from '@blue/services/environment';
import { throwError, from } from 'rxjs';
import { mergeMap, map } from 'rxjs/operators';
import { formatDate, DatePipe, CommonModule } from '@angular/common';
import { addDays } from 'date-fns';
import * as i2 from '@bm-uktax/uk-hmrc-fraud-prevention';
import { UkHmrcFraudPreventionService } from '@bm-uktax/uk-hmrc-fraud-prevention';
import { getCompanyId } from '@blue/services/session';
import { BrowserModule } from '@angular/platform-browser';
import { Validators, FormBuilder, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { BentoModule } from '@bento/bento-ng';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
import * as ɵngcc2 from '@bm-uktax/uk-hmrc-fraud-prevention';
import * as ɵngcc3 from '@bento/bento-ng';
import * as ɵngcc4 from '@angular/common';
import * as ɵngcc5 from '@angular/forms';

function UkTaxPeriodsComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.notApplicableMessage(), " ");
} }
function UkTaxPeriodsComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div")(1, "div", 2)(2, "div", 3)(3, "div");
    ɵngcc0.ɵɵelement(4, "uk-tax-periods-accounting-period", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div");
    ɵngcc0.ɵɵelement(6, "uk-tax-periods-grid", 4);
    ɵngcc0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("contactId", ctx_r1.contactId)("periodType", ctx_r1.periodType);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("contactId", ctx_r1.contactId)("periodType", ctx_r1.periodType);
} }
function UkTaxPeriodsAccountingPeriodComponent_option_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "date");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ap_r1 = ctx.$implicit;
    ɵngcc0.ɵɵpropertyInterpolate("value", ap_r1.id);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(2, 2, ap_r1.endDate, "dd/MM/yyyy"));
} }
function UkTaxPeriodsGridComponent_p_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.errorMessage);
} }
function UkTaxPeriodsGridComponent_div_11_th_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th", 7);
    ɵngcc0.ɵɵtext(1, "Filing Status");
    ɵngcc0.ɵɵelementEnd();
} }
function UkTaxPeriodsGridComponent_div_11_tbody_11_tr_1_td_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "td");
    ɵngcc0.ɵɵtext(1, "Unknown");
    ɵngcc0.ɵɵelementEnd();
} }
function UkTaxPeriodsGridComponent_div_11_tbody_11_tr_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr")(1, "td", 11);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "td");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "date");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "td");
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵpipe(8, "ukTaxPeriodsHmrcStatus");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(9, UkTaxPeriodsGridComponent_div_11_tbody_11_tr_1_td_9_Template, 2, 0, "td", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const definedPeriod_r5 = ctx.$implicit;
    const i_r6 = ctx.index;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(i_r6 + 1);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(5, 4, definedPeriod_r5.periodEndDate, "dd/MM/yyyy"), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(8, 7, definedPeriod_r5.isHmrcPeriod));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", false);
} }
function UkTaxPeriodsGridComponent_div_11_tbody_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tbody");
    ɵngcc0.ɵɵtemplate(1, UkTaxPeriodsGridComponent_div_11_tbody_11_tr_1_Template, 10, 9, "tr", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.taxObligationPeriods);
} }
function UkTaxPeriodsGridComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div")(1, "table", 6)(2, "thead")(3, "tr")(4, "th", 7);
    ɵngcc0.ɵɵtext(5, "Period");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "th", 7);
    ɵngcc0.ɵɵtext(7, "Period End Date");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "th", 7);
    ɵngcc0.ɵɵtext(9, "HMRC Status");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(10, UkTaxPeriodsGridComponent_div_11_th_10_Template, 2, 0, "th", 8);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵtemplate(11, UkTaxPeriodsGridComponent_div_11_tbody_11_Template, 2, 1, "tbody", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(12, "div", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(10);
    ɵngcc0.ɵɵproperty("ngIf", false);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.isLoading);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("bentoBusyLoader", ctx_r1.isLoading)("size", "sm");
} }
function sortByDate(a, b) {
    const dateA = new Date(a).getTime();
    const dateB = new Date(b).getTime();
    return dateA > dateB ? 1 : -1;
}
function preparePeriodEndDates(periods, format, culture = 'en-GB') {
    const endDates = [];
    if (periods) {
        periods.forEach(period => {
            endDates.push(formatDate(period.endDate, format, culture));
        });
    }
    return endDates;
}
// Currently only 12 month accounting periods handled
function getUkTaxPeriodsAccountingPeriodStartDate(accountingPeriod) {
    let startDate = new Date(accountingPeriod.endDate.valueOf());
    startDate.setFullYear(startDate.getFullYear() - 1);
    startDate = addDays(startDate, 1);
    return startDate;
}

function handleHttpError(error) {
    return throwError(getError(error));
}
function getError(error) {
    // Errors come in various flavours
    if (error instanceof Error) {
        if (error.name === 'TimeoutError') {
            return { code: -1, message: 'Connectivity problems prevented the server from responding. Please try again.' };
        }
        else {
            console.error(error);
            return { code: -1, message: error.message };
        }
    }
    else if (error.error instanceof ErrorEvent) {
        console.error(error);
        return { code: -1, message: 'An unexpected error has occurred.' };
    }
    else if (error.status >= 500 && error.status < 600) {
        console.error(error);
        if (error.headers && error.headers.get('x-chain-id')) {
            console.log(`*** Please report the following error code to Onvio support: ${error.headers.get('x-chain-id')}`);
        }
        return { code: error.status, message: 'An unexpected error has occurred.' };
    }
    else if (error.error) {
        try {
            // Error body json may consist of various formats
            const errorBody = error.error.json ? error.json() : error.error;
            if (errorBody.data && errorBody.data.error) {
                return { code: error.status, message: errorBody.data.error };
            }
            else if (errorBody.error && errorBody.error.message) {
                return { code: error.status, message: errorBody.error.message };
            }
            else if (errorBody.error) {
                return { code: error.status, message: errorBody.error };
            }
            else if (errorBody.message) {
                return { code: error.status, message: errorBody.message };
            }
            else {
                return { code: error.status, message: error.statusText ? error.statusText : 'An unexpected error has occurred.' };
            }
        }
        catch (_a) {
            // No error body json data
            return { code: error.status, message: error.statusText ? error.statusText : 'An unexpected error has occurred.' };
        }
    }
    else {
        // No error body
        return { code: error.status, message: error.statusText ? error.statusText : 'An unexpected error has occurred.' };
    }
}

class UkTaxPeriodsService {
    constructor(http, ukHmrcFraudPreventionService) {
        this.http = http;
        this.ukHmrcFraudPreventionService = ukHmrcFraudPreventionService;
        this.getRoute = getRoute;
        this.accountingPeriodChange = new EventEmitter();
    }
    handleaccountingPeriodChange(accountingPeriod) {
        this.accountingPeriodChange.emit(accountingPeriod);
    }
    getTaxObligationPeriodsByContactId(contactId, accountingPeriod, periodType) {
        return __awaiter(this, void 0, void 0, function* () {
            const options = yield this.getRequestOptions();
            console.log('options', options);
            const body = this.getBodyOptions(accountingPeriod.periods, periodType);
            return from(this.getBasePath('UKTaxServices')).pipe(mergeMap((basePath) => this.http.post(`${basePath}/v1/contact/${contactId}/tax-year/obligation-periods/search`, body, options)), map((data) => data.data.items))
                .toPromise();
        });
    }
    getContactEntityType(companyId, contactId) {
        return __awaiter(this, void 0, void 0, function* () {
            const basePath = yield this.getBasePath('CoreServices');
            const uri = `${basePath}/v7/companies/${companyId}/contacts/${contactId}`;
            return yield this.http.get(uri).toPromise()
                .then(response => response.entityType.id)
                .catch((e) => { handleHttpError(e); return ''; });
        });
    }
    getAccountingFiscalYearsWithPeriodsByContactId(contactId) {
        return from(this.getBasePath('AccountingServices')).pipe(mergeMap((basePath) => this.http.get(`${basePath}/v2/${contactId}/fiscalYear?includePeriods=true`)));
    }
    getBasePath(serviceName) {
        return this.getRoute(serviceName)
            .then(result => this.stripDomainName(result))
            .catch((e) => { handleHttpError(e); return ''; });
    }
    getRequestOptions() {
        return __awaiter(this, void 0, void 0, function* () {
            const headers = yield this.ukHmrcFraudPreventionService.getHeaders();
            headers.append('Content-Type', 'application/json');
            return { headers };
        });
    }
    getBodyOptions(periods, periodType) {
        const options = {
            PeriodEndDates: preparePeriodEndDates(periods, 'yyyy-MM-dd'),
            PeriodType: periodType
        };
        return options;
    }
    stripDomainName(route) {
        let routeSegments = route.split('/');
        routeSegments = routeSegments.slice(3, routeSegments.length);
        return '/' + routeSegments.join('/');
    }
}
UkTaxPeriodsService.ɵfac = function UkTaxPeriodsService_Factory(t) { return new (t || UkTaxPeriodsService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ɵngcc2.UkHmrcFraudPreventionService)); };
UkTaxPeriodsService.ɵprov = i0.ɵɵdefineInjectable({ factory: function UkTaxPeriodsService_Factory() { return new UkTaxPeriodsService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.UkHmrcFraudPreventionService)); }, token: UkTaxPeriodsService, providedIn: "root" });
UkTaxPeriodsService.ctorParameters = () => [
    { type: HttpClient },
    { type: UkHmrcFraudPreventionService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UkTaxPeriodsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ɵngcc2.UkHmrcFraudPreventionService }]; }, null); })();

var PeriodType;
(function (PeriodType) {
    PeriodType[PeriodType["None"] = 0] = "None";
    PeriodType[PeriodType["Tax"] = 5] = "Tax";
    PeriodType[PeriodType["Property"] = 6] = "Property";
})(PeriodType || (PeriodType = {}));

class UkTaxPeriodsComponent {
    constructor(service) {
        this.service = service;
        this.getCompanyId = getCompanyId;
        this.applicableEntityTypes = ['GBSOLETRADE', 'GBRENTALPROPERTIES', 'GBFURNISHEDHOLIDAYLETTINGS'];
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.isLoading = true;
            this.companyId = yield this.getCompanyId();
            this.contactEntityType = yield this.service.getContactEntityType(this.companyId, this.contactId);
            this.setPeriodType(this.contactEntityType);
            this.isInit = true;
            this.isLoading = false;
        });
    }
    ngOnChanges(changes) {
        return __awaiter(this, void 0, void 0, function* () {
            if (changes.contactId && this.isInit) {
                this.isLoading = true;
                this.contactId = changes.contactId.currentValue;
                this.contactEntityType = yield this.service.getContactEntityType(this.companyId, this.contactId);
                this.setPeriodType(this.contactEntityType);
                this.isLoading = false;
            }
        });
    }
    notApplicableMessage() {
        return 'Tax periods are not applicable for this entity type.';
    }
    isApplicable() {
        return this.applicableEntityTypes.includes(this.contactEntityType) ? true : false;
    }
    setPeriodType(contactEntityType) {
        switch (contactEntityType) {
            case 'GBSOLETRADE':
                this.periodType = PeriodType.Tax;
                break;
            case 'GBFURNISHEDHOLIDAYLETTINGS':
            case 'GBRENTALPROPERTIES':
                this.periodType = PeriodType.Property;
                break;
            default: this.periodType = PeriodType.None;
        }
    }
}
UkTaxPeriodsComponent.ɵfac = function UkTaxPeriodsComponent_Factory(t) { return new (t || UkTaxPeriodsComponent)(ɵngcc0.ɵɵdirectiveInject(UkTaxPeriodsService)); };
UkTaxPeriodsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: UkTaxPeriodsComponent, selectors: [["uk-tax-periods"]], inputs: { contactId: "contactId" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 3, vars: 4, consts: [[1, "ng-bento", "busyLoader", 3, "bentoBusyLoader", "size"], [4, "ngIf"], [1, "row"], [1, "col-xs-12"], [3, "contactId", "periodType"]], template: function UkTaxPeriodsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, UkTaxPeriodsComponent_div_1_Template, 2, 1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, UkTaxPeriodsComponent_div_2_Template, 7, 4, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("bentoBusyLoader", ctx.isLoading)("size", "sm");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isApplicable());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isApplicable());
    } }, directives: function () { return [ɵngcc3.BentoBusyLoaderDirective, ɵngcc4.NgIf, UkTaxPeriodsAccountingPeriodComponent, UkTaxPeriodsGridComponent]; }, encapsulation: 2 });
UkTaxPeriodsComponent.ctorParameters = () => [
    { type: UkTaxPeriodsService }
];
UkTaxPeriodsComponent.propDecorators = {
    contactId: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UkTaxPeriodsComponent, [{
        type: Component,
        args: [{
                selector: 'uk-tax-periods',
                template: "<div class=\"ng-bento busyLoader\" [bentoBusyLoader]=\"isLoading\" [size]=\"'sm'\" >\n  <div *ngIf=\"!isApplicable()\">\n    {{ notApplicableMessage() }}\n  </div>\n  <div *ngIf=\"isApplicable()\">\n    <div class=\"row\">\n      <div class=\"col-xs-12\">\n        <div>\n          <uk-tax-periods-accounting-period [contactId]=\"contactId\" [periodType]=\"periodType\"></uk-tax-periods-accounting-period>\n        </div>\n        <div>\n          <uk-tax-periods-grid [contactId]=\"contactId\" [periodType]=\"periodType\"></uk-tax-periods-grid>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"
            }]
    }], function () { return [{ type: UkTaxPeriodsService }]; }, { contactId: [{
            type: Input
        }] }); })();

class UkTaxPeriodsAccountingPeriodComponent {
    constructor(ukTaxPeriodsService, formBuilder) {
        this.ukTaxPeriodsService = ukTaxPeriodsService;
        this.formBuilder = formBuilder;
        this.datePipe = new DatePipe('en-GB');
    }
    ngOnInit() {
        this.accountingPeriodForm = this.formBuilder.group({
            periodList: ['', Validators.required],
            selectedPeriodDisplay: ['', Validators.required]
        });
        this.accountingPeriodForm.controls['periodList'].valueChanges.subscribe(form => {
            this.applyFormValues(this.accountingPeriodForm, form);
        });
        this.ukTaxPeriodsService.getAccountingFiscalYearsWithPeriodsByContactId(this.contactId).subscribe((observer) => {
            this.accountingPeriods = observer;
            this.accountingPeriods.data.sort((a, b) => sortByDate(b.endDate, a.endDate));
            this.accountingPeriodForm.controls['periodList'].setValue(this.accountingPeriods.data[0].id);
        });
        this.isInit = true;
    }
    ngOnChanges(changes) {
        if (changes.contactId && this.isInit) {
            this.ukTaxPeriodsService.handleaccountingPeriodChange(null);
            this.accountingPeriods = {
                id: '',
                apiVersion: 0,
                data: []
            };
            this.accountingPeriodForm.reset();
            this.ukTaxPeriodsService.getAccountingFiscalYearsWithPeriodsByContactId(this.contactId).subscribe((observer) => {
                this.accountingPeriods = observer;
                this.accountingPeriods.data.sort((a, b) => sortByDate(b.endDate, a.endDate));
                this.accountingPeriodForm.controls['periodList'].setValue(this.accountingPeriods.data[0].id);
            });
        }
    }
    applyFormValues(group, formValues) {
        if (formValues) {
            const selectedPeriod = this.accountingPeriods.data.find(({ id }) => id === formValues);
            const formControl = group.controls['selectedPeriodDisplay'];
            formControl.setValue(`${this.datePipe.transform(getUkTaxPeriodsAccountingPeriodStartDate(selectedPeriod), 'dd/MM/yyyy')} -` +
                ` ${this.datePipe.transform(selectedPeriod.endDate, 'dd/MM/yyyy')}`);
            this.ukTaxPeriodsService.handleaccountingPeriodChange(selectedPeriod);
        }
    }
}
UkTaxPeriodsAccountingPeriodComponent.ɵfac = function UkTaxPeriodsAccountingPeriodComponent_Factory(t) { return new (t || UkTaxPeriodsAccountingPeriodComponent)(ɵngcc0.ɵɵdirectiveInject(UkTaxPeriodsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.FormBuilder)); };
UkTaxPeriodsAccountingPeriodComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: UkTaxPeriodsAccountingPeriodComponent, selectors: [["uk-tax-periods-accounting-period"]], inputs: { contactId: "contactId", periodType: "periodType" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 11, vars: 3, consts: [[1, "col-md-6", "col-sm-6", "col-lg-6"], ["novalidate", "", 3, "formGroup"], [1, "form-group"], ["for", "periodList", 1, "ng-scope"], ["bentoSelect", "", "formControlName", "periodList", "placeholder", "Please choose", 1, "form-control", "accountingPeriodsSelect"], [3, "value", 4, "ngFor", "ngForOf"], [1, "ng-scope"], ["type", "text", "formControlName", "selectedPeriodDisplay", 1, "form-control"], [3, "value"]], template: function UkTaxPeriodsAccountingPeriodComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "form", 1)(2, "div", 2)(3, "label", 3);
        ɵngcc0.ɵɵtext(4, "Select Fiscal Year");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "select", 4);
        ɵngcc0.ɵɵtemplate(6, UkTaxPeriodsAccountingPeriodComponent_option_6_Template, 3, 5, "option", 5);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(7, "div", 2)(8, "label", 6);
        ɵngcc0.ɵɵtext(9, "Accounting Period");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(10, "input", 7);
        ɵngcc0.ɵɵelementEnd()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formGroup", ctx.accountingPeriodForm);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.accountingPeriods == null ? null : ctx.accountingPeriods.data);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵattribute("disabled", true);
    } }, directives: [ɵngcc5.ɵNgNoValidate, ɵngcc5.NgControlStatusGroup, ɵngcc5.FormGroupDirective, ɵngcc3.BentoSelectDirective, ɵngcc5.SelectControlValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.FormControlName, ɵngcc4.NgForOf, ɵngcc5.NgSelectOption, ɵngcc5.ɵNgSelectMultipleOption, ɵngcc5.DefaultValueAccessor], pipes: [ɵngcc4.DatePipe], styles: [".accountingPeriodsSelect[_ngcontent-%COMP%]{-webkit-appearance:auto}"] });
UkTaxPeriodsAccountingPeriodComponent.ctorParameters = () => [
    { type: UkTaxPeriodsService },
    { type: FormBuilder }
];
UkTaxPeriodsAccountingPeriodComponent.propDecorators = {
    contactId: [{ type: Input }],
    periodType: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UkTaxPeriodsAccountingPeriodComponent, [{
        type: Component,
        args: [{
                selector: 'uk-tax-periods-accounting-period',
                template: "<div class=\"col-md-6 col-sm-6 col-lg-6\">\n  <form [formGroup]=\"accountingPeriodForm\" novalidate>\n    <div class=\"form-group\">\n      <label class=\"ng-scope\" for=\"periodList\">Select Fiscal Year</label>\n      <select bentoSelect class=\"form-control accountingPeriodsSelect\" formControlName=\"periodList\" placeholder=\"Please choose\">\n        <option *ngFor=\"let ap of accountingPeriods?.data\" value=\"{{ap.id}}\">{{ap.endDate | date :\n          'dd/MM/yyyy'}}</option>\n      </select>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"ng-scope\">Accounting Period</label>\n      <input class=\"form-control\" type=\"text\" formControlName=\"selectedPeriodDisplay\" [attr.disabled]=\"true\">\n    </div>\n  </form>\n</div>\n",
                styles: [".accountingPeriodsSelect{-webkit-appearance:auto}"]
            }]
    }], function () { return [{ type: UkTaxPeriodsService }, { type: ɵngcc5.FormBuilder }]; }, { contactId: [{
            type: Input
        }], periodType: [{
            type: Input
        }] }); })();

class UkTaxPeriodsGridComponent {
    constructor(ukTaxPeriodsService) {
        this.ukTaxPeriodsService = ukTaxPeriodsService;
        this.taxErrorMessage = 'No periods are available to be displayed. Navigate to the HMRC tab of client and import required periods.';
        this.propertyErrorMessage = 'Property Periods not yet imported from HMRC. Import via Landlord HMRC section.';
        this.taxObligationPeriods = [];
    }
    ngOnInit() {
        this.accountingPeriodSubscription = this.ukTaxPeriodsService.accountingPeriodChange.subscribe(ap => { this.applyGridValues(ap); });
    }
    applyGridValues(accountingPeriod) {
        this.errorMessage = '';
        if (accountingPeriod) {
            this.isLoading = true;
            this.ukTaxPeriodsService.getTaxObligationPeriodsByContactId(this.contactId, accountingPeriod, this.periodType)
                .then((periods) => {
                this.taxObligationPeriods = periods.sort((a, b) => sortByDate(a.periodEndDate, b.periodEndDate));
                this.isLoading = false;
            }, (error) => {
                this.taxObligationPeriods = [];
                if (error.status === 404) {
                    this.setErrorMessage(this.periodType);
                }
                this.isLoading = false;
            });
        }
        else {
            this.taxObligationPeriods = [];
        }
    }
    ngOnDestroy() {
        this.accountingPeriodSubscription.unsubscribe();
    }
    setErrorMessage(periodType) {
        switch (periodType) {
            case PeriodType.Tax:
                this.errorMessage = this.taxErrorMessage;
                break;
            case PeriodType.Property:
                this.errorMessage = this.propertyErrorMessage;
                break;
            default: this.errorMessage = '';
        }
    }
}
UkTaxPeriodsGridComponent.ɵfac = function UkTaxPeriodsGridComponent_Factory(t) { return new (t || UkTaxPeriodsGridComponent)(ɵngcc0.ɵɵdirectiveInject(UkTaxPeriodsService)); };
UkTaxPeriodsGridComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: UkTaxPeriodsGridComponent, selectors: [["uk-tax-periods-grid"]], inputs: { contactId: "contactId", periodType: "periodType" }, decls: 12, vars: 5, consts: [[1, "col-md-9", "col-sm-9", "col-lg-9"], [1, "form-group"], ["for", "periodFrequency", 1, "ng-scope"], ["bentoSelect", "", "name", "periodFrequency", "disabled", "", 1, "form-control"], ["value", "4"], [4, "ngIf"], [1, "table"], ["scope", "col"], ["scope", "col", 4, "ngIf"], [1, "busyLoader", 3, "bentoBusyLoader", "size"], [4, "ngFor", "ngForOf"], ["scope", "row"]], template: function UkTaxPeriodsGridComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "label", 2);
        ɵngcc0.ɵɵtext(3, "Period Frequency");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "select", 3)(5, "option", 4);
        ɵngcc0.ɵɵtext(6, "Quarterly");
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(7, "h1");
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵpipe(9, "periodTypeToText");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(10, UkTaxPeriodsGridComponent_p_10_Template, 2, 1, "p", 5);
        ɵngcc0.ɵɵtemplate(11, UkTaxPeriodsGridComponent_div_11_Template, 13, 4, "div", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(9, 3, ctx.periodType), " Periods");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.errorMessage);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.errorMessage);
    } }, directives: function () { return [ɵngcc3.BentoSelectDirective, ɵngcc5.NgSelectOption, ɵngcc5.ɵNgSelectMultipleOption, ɵngcc4.NgIf, ɵngcc4.NgForOf, ɵngcc3.BentoBusyLoaderDirective]; }, pipes: function () { return [PeriodTypeToTextPipe, ɵngcc4.DatePipe, UkTaxPeriodsHmrcStatusPipe]; }, styles: [""] });
UkTaxPeriodsGridComponent.ctorParameters = () => [
    { type: UkTaxPeriodsService }
];
UkTaxPeriodsGridComponent.propDecorators = {
    contactId: [{ type: Input }],
    periodType: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UkTaxPeriodsGridComponent, [{
        type: Component,
        args: [{
                selector: 'uk-tax-periods-grid',
                template: "<div class=\"col-md-9 col-sm-9 col-lg-9\">\n  <div class=\"form-group\">\n    <label class=\"ng-scope\" for=\"periodFrequency\">Period Frequency</label>\n    <select bentoSelect class=\"form-control\" name=\"periodFrequency\" disabled>\n      <option value=\"4\">Quarterly</option>\n    </select>\n  </div>\n  <h1>{{periodType | periodTypeToText}} Periods</h1>\n  <p *ngIf=\"errorMessage\">{{errorMessage}}</p>\n  <div *ngIf=\"!errorMessage\">\n    <table class=\"table\">\n      <thead>\n        <tr>\n          <th scope=\"col\">Period</th>\n          <th scope=\"col\">Period End Date</th>\n          <th scope=\"col\">HMRC Status</th>\n          <th  *ngIf=\"false\" scope=\"col\">Filing Status</th>\n        </tr>\n      </thead>\n      <tbody *ngIf=\"!isLoading\">\n        <tr *ngFor=\"let definedPeriod of taxObligationPeriods; index as i\">\n          <td scope=\"row\">{{ i + 1}}</td>\n          <td>\n            {{ definedPeriod.periodEndDate | date : 'dd/MM/yyyy'}}\n          </td>\n          <td>{{ definedPeriod.isHmrcPeriod | ukTaxPeriodsHmrcStatus}}</td>\n          <td *ngIf=\"false\">Unknown</td>\n        </tr>\n      </tbody>\n    </table>\n    <div class=\"busyLoader\" [bentoBusyLoader]=\"isLoading\" [size]=\"'sm'\"></div>\n  </div>\n</div>\n",
                styles: [""]
            }]
    }], function () { return [{ type: UkTaxPeriodsService }]; }, { contactId: [{
            type: Input
        }], periodType: [{
            type: Input
        }] }); })();

class UkTaxPeriodsHmrcStatusPipe {
    transform(value) {
        return value ? 'Confirmed' : 'Not Available';
    }
}
UkTaxPeriodsHmrcStatusPipe.ɵfac = function UkTaxPeriodsHmrcStatusPipe_Factory(t) { return new (t || UkTaxPeriodsHmrcStatusPipe)(); };
UkTaxPeriodsHmrcStatusPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "ukTaxPeriodsHmrcStatus", type: UkTaxPeriodsHmrcStatusPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UkTaxPeriodsHmrcStatusPipe, [{
        type: Pipe,
        args: [{
                name: 'ukTaxPeriodsHmrcStatus'
            }]
    }], null, null); })();

class PeriodTypeToTextPipe {
    transform(value) {
        switch (value) {
            case PeriodType.Tax: return 'Tax';
            case PeriodType.Property: return 'Property';
            default: return '';
        }
    }
}
PeriodTypeToTextPipe.ɵfac = function PeriodTypeToTextPipe_Factory(t) { return new (t || PeriodTypeToTextPipe)(); };
PeriodTypeToTextPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "periodTypeToText", type: PeriodTypeToTextPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PeriodTypeToTextPipe, [{
        type: Pipe,
        args: [{
                name: 'periodTypeToText'
            }]
    }], null, null); })();

class UkTaxPeriodsModule {
}
UkTaxPeriodsModule.ɵfac = function UkTaxPeriodsModule_Factory(t) { return new (t || UkTaxPeriodsModule)(); };
UkTaxPeriodsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: UkTaxPeriodsModule });
UkTaxPeriodsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [UkTaxPeriodsService], imports: [[
            CommonModule,
            BrowserModule,
            HttpClientModule,
            ReactiveFormsModule,
            FormsModule,
            BentoModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UkTaxPeriodsModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    UkTaxPeriodsComponent,
                    UkTaxPeriodsAccountingPeriodComponent,
                    UkTaxPeriodsGridComponent,
                    UkTaxPeriodsHmrcStatusPipe,
                    PeriodTypeToTextPipe
                ],
                imports: [
                    CommonModule,
                    BrowserModule,
                    HttpClientModule,
                    ReactiveFormsModule,
                    FormsModule,
                    BentoModule
                ],
                exports: [UkTaxPeriodsComponent],
                providers: [UkTaxPeriodsService],
                entryComponents: [UkTaxPeriodsComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(UkTaxPeriodsModule, { declarations: function () { return [UkTaxPeriodsComponent, UkTaxPeriodsAccountingPeriodComponent, UkTaxPeriodsGridComponent, UkTaxPeriodsHmrcStatusPipe, PeriodTypeToTextPipe]; }, imports: function () { return [CommonModule,
        BrowserModule,
        HttpClientModule,
        ReactiveFormsModule,
        FormsModule,
        BentoModule]; }, exports: function () { return [UkTaxPeriodsComponent]; } }); })();

/*
 * Public API Surface of uk-tax-periods
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UkTaxPeriodsComponent, UkTaxPeriodsModule, UkTaxPeriodsService, UkTaxPeriodsAccountingPeriodComponent as ɵa, UkTaxPeriodsGridComponent as ɵb, UkTaxPeriodsHmrcStatusPipe as ɵc, PeriodTypeToTextPipe as ɵd };

